import React from 'react';

const PageTransition = () => {
  return (
    <div className="page-transition fixed inset-0 bg-[var(--primary)] z-[9999] origin-bottom scale-y-0 pointer-events-none" />
  );
};

export default PageTransition;
